import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { fetchBigCommerceApi, HTTP_METHOD } from 'utils/bigCommerceAuth';
import { ProductReviewResponse } from 'components/ProductInformationWrapper';
import {Product, Props as ProductType} from '@bepure/tarkin';
import Slider from 'react-slick';


declare const BASE_API_URL: string;

export interface ProductCarouselProps {
    title?: string;
    products: ProductType[];
}

const slickMobileSettings = {
  dots: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  swipeToSlide: true,
  arrows: false
}

const slickDesktopSettings = {
  dots: false,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 4,
  swipeToSlide: true,
  arrows: false,
  swipe: false
}


const ProductCarousel = (props: ProductCarouselProps) => {


  const products: JSX.Element[] = props.products.map((element, index) => {
    return (
        <Product
            key={index}
            imageUrl={element.imageUrl}
            score={element.score}
            title={element.title}
            description={element.description}
            price={element.price}
            button={element.button}
            pageUrl={element.pageUrl}
        />
    );
  });

  return (
    <div className="most-popular">
      <h1 className="most-popular__title">
        {props.title}
      </h1>
      <Slider {...slickMobileSettings}className="most-popular__products most-popular__mobile">
          {products}
      </Slider>
      <Slider {...slickDesktopSettings}className="most-popular__products most-popular__desktop">
          {products}
      </Slider>

    </div>
  )
}


const getProducts = async (pageLinks: any) => {
    const reviews = await fetchProductReviewStats();
    const response = await getBigCommerceFeaturedProducts();
    const json = await response.json();
    pageLinks = pageLinks.replaceAll("'", '"');
    return mapProducts(json, JSON.parse(pageLinks), reviews);
}

const mapProducts = (productResponseJSON: any, pageLinks: any, reviews: any) => {
    const products = productResponseJSON.data.site?.featuredProducts.edges.map((item: any) => {
        return {
            title: item.node.name,
            imageUrl: item.node.defaultImage.imageUrl,
            score: reviews.data[item.node.sku] ? reviews.data[item.node.sku].score : 0,
            description: item.node.plainTextDescription,
            price: item.node.prices.price.value,
            pageUrl: pageLinks[item.node.sku]
        }
    });
    return products;
}

 const getBigCommerceFeaturedProducts = async () => {
    const featuredProducts = await fetchBigCommerceApi(HTTP_METHOD.POST, new Headers(), {
      query: `query paginateProducts(
        $pageSize: Int = 4
        $cursor: String
        $currencyCode: currencyCode = NZD
      ) {
        site {
            featuredProducts (first: $pageSize, after:$cursor) {
            pageInfo {
              startCursor
              endCursor
            }
            edges {
              cursor
              node {
                entityId
                sku
                name
                plainTextDescription
                defaultImage {
                  imageUrl: url(width: 660)
                  altText
                }
                prices (currencyCode: $currencyCode, includeTax: true) {
                  price {
                    value
                    currencyCode
                  }
                }
              }
            }
          }
        }
      }
      `,
      variables: {
        currencyCode: localStorage.currency || 'NZD'
      }
    })
    return featuredProducts
};

const fetchProductReviewStats = async () => {
    const response = await fetch(`${BASE_API_URL}/v1/service/product-management/products/reviews`, {
        method: 'GET',
    })
    try {
        const reviews: ProductReviewResponse = await response.json();
        return Promise.resolve(reviews);
    } catch (error) {
        return Promise.reject({
            error: error.message,
        });
    }
}

export default function render() {
    const elements = document.getElementsByClassName('product-carousel-section');
    Array.prototype.map.call(elements, (element: HTMLElement) => {
        const title = element.dataset.title ? element.dataset.title : null;
        const pageLinks = element.dataset.pagelink;
        getProducts(pageLinks).then((products: ProductType[]) => {
            if (products) {
                return ReactDOM.render(
                  <ProductCarousel title={title ? title : ''} products={products} />
                    , element)
            }
        })
    });
}


